import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/** "Tour this page" for the Blog workspace (/studio/blog). Anchors live in BlogWorkspacePage.tsx. */
export function getBlogTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'Write a blog',
        description:
          'Blog posts attract buyers and sellers and help your site show up on Google. Here’s how ' +
          'the workspace works.',
      },
    },
    {
      element: at('blog-new-post'),
      popover: {
        title: 'Start a post',
        description: 'Create a new blank post to start writing.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: at('blog-ai-chat'),
      popover: {
        title: 'Let AI draft it',
        description:
          'Describe what the post should be about and the AI drafts it into the preview — then you ' +
          'review and tweak. Use it to generate a new post or rewrite your current draft.',
        side: 'right',
        align: 'start',
      },
    },
    {
      element: at('blog-edit'),
      popover: {
        title: 'Edit the details',
        description:
          'Fine-tune the title, body, excerpt, and cover image. Everything you change shows in the ' +
          'preview instantly.',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: at('blog-preview'),
      popover: {
        title: 'See it live',
        description: 'This is how your post will look on your website, updating as you type.',
        side: 'left',
        align: 'center',
      },
    },
    {
      element: at('blog-save'),
      popover: {
        title: 'Save & publish',
        description:
          'Save your draft anytime. Flip the “Published” toggle when you’re ready for it to go live ' +
          'on your site.',
        side: 'top',
        align: 'end',
      },
    },
  ];
}
